import { useEffect } from 'react';

import { useAuth } from './auth';

const ADSENSE_CLIENT_ID = 'ca-pub-7640321340504385';
const ADSENSE_SCRIPT_ID = 'google-adsense-script';
const ADSENSE_SCRIPT_SRC = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT_ID}`;

declare global {
  interface Window {
    adsbygoogle?: unknown[];
  }
}

export function AdSenseLoader() {
  const { isLoading, user } = useAuth();
  const shouldLoadAds = !isLoading && !user?.is_premium;

  useEffect(() => {
    const existingScript = document.getElementById(ADSENSE_SCRIPT_ID);

    if (!shouldLoadAds) {
      existingScript?.remove();
      return;
    }

    if (existingScript) {
      return;
    }

    const script = document.createElement('script');
    script.id = ADSENSE_SCRIPT_ID;
    script.async = true;
    script.src = ADSENSE_SCRIPT_SRC;
    script.crossOrigin = 'anonymous';
    document.head.appendChild(script);
  }, [shouldLoadAds]);

  return null;
}
